(() => {
  const BASE_CONFIG_SELECTOR = '[data-eg-digital-config]';
  const UX_CONFIG_SELECTOR = '[data-eg-digital-cart-ux-config]';
  const META_SELECTOR = '[data-eg-digital-cart-meta]';
  const MODULE_SELECTOR = '[data-eg-digital-cart-module]';
  const ATTRIBUTE_CHANNEL = 'Entrega digital - canal';
  const ATTRIBUTE_CONTACT = 'Entrega digital - contacto';
  let cartRequest = null;
  let enhanceTimer = null;

  const readJson = (selector) => {
    const node = document.querySelector(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  };

  const cartRoot = () => window.Shopify?.routes?.root || '/';

  const fetchCart = () => {
    if (cartRequest) return cartRequest;
    cartRequest = fetch(`${cartRoot()}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .finally(() => { cartRequest = null; });
    return cartRequest;
  };

  const protectModule = (module) => {
    if (module.dataset.egDigitalCartGuard === 'true') return;
    module.dataset.egDigitalCartGuard = 'true';
    module.addEventListener('change', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target?.closest('[data-eg-digital-preference]')) return;
      event.stopPropagation();
      window.setTimeout(scheduleEnhance, 900);
    });
  };

  const text = (value, fallback = '') => String(value ?? fallback).trim();
  const setNodeText = (node, value) => {
    if (!node) return;
    const next = text(value);
    if (node.textContent !== next) node.textContent = next;
  };

  const syncDigitalPaymentPolicy = (uxConfig) => {
    const payment = text(uxConfig?.digitalPaymentText, 'Depósito o transferencia bancaria');
    if (!payment) return;
    document.querySelectorAll('[data-eg-digital-product-module] [data-eg-digital-field="beforePaymentText"]').forEach((node) => setNodeText(node, payment));
    document.querySelectorAll('[data-eg-digital-product-module] [data-eg-digital-field="paymentText"]').forEach((node) => setNodeText(node, `Pago mediante ${payment}.`));
  };

  const makeIcon = (symbol) => {
    const icon = document.createElement('span');
    icon.className = 'eg-cart-ux__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = symbol;
    return icon;
  };

  const makeFact = (label, value, symbol, modifier = '') => {
    if (!value) return null;
    const row = document.createElement('div');
    row.className = `eg-cart-ux__fact${modifier ? ` eg-cart-ux__fact--${modifier}` : ''}`;
    row.appendChild(makeIcon(symbol));
    const copy = document.createElement('div');
    copy.className = 'eg-cart-ux__fact-copy';
    const strong = document.createElement('strong');
    strong.textContent = `${label}:`;
    const span = document.createElement('span');
    span.textContent = value;
    copy.append(strong, span);
    row.appendChild(copy);
    return row;
  };

  const unique = (values) => [...new Set(values.map((value) => text(value)).filter(Boolean))];

  const summarizeMeta = (digitalItems, metaMap) => {
    const metas = digitalItems.map((item) => metaMap?.[String(item.variant_id)] || null).filter(Boolean);
    const regions = unique(metas.map((meta) => meta.region));
    const redeems = unique(metas.map((meta) => meta.redeem));
    return {
      region: regions.length === 1 ? regions[0] : regions.length > 1 ? regions.join(' · ') : '',
      redeem: redeems.length === 1 ? redeems[0] : redeems.length > 1 ? redeems.join(' · ') : ''
    };
  };

  const syncCompactPreference = (preference, uxConfig) => {
    if (!preference) return;
    preference.classList.add('eg-cart-ux__preference');

    const choiceGroup = preference.querySelector('.eg-digital-cart__channel-options');
    const radios = [...preference.querySelectorAll('input[data-eg-digital-channel-option]')];
    if (!choiceGroup || !radios.length) return;

    let channelRow = preference.querySelector('[data-eg-cart-ux-channel-row]');
    let select = preference.querySelector('[data-eg-cart-ux-channel-select]');
    if (!channelRow) {
      channelRow = document.createElement('label');
      channelRow.className = 'eg-cart-ux__preference-row';
      channelRow.dataset.egCartUxChannelRow = '';
      const label = document.createElement('span');
      label.className = 'eg-cart-ux__preference-label';
      label.dataset.egCartUxChannelLabel = '';
      select = document.createElement('select');
      select.className = 'eg-cart-ux__select';
      select.dataset.egCartUxChannelSelect = '';
      channelRow.append(label, select);
      preference.insertBefore(channelRow, choiceGroup);

      select.addEventListener('change', () => {
        const radio = radios.find((candidate) => candidate.value === select.value);
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    const channelLabel = channelRow.querySelector('[data-eg-cart-ux-channel-label]');
    setNodeText(channelLabel, uxConfig.digitalChannelLabel || 'Recibir código por');

    const checked = radios.find((radio) => radio.checked);
    const current = checked?.value || '';
    const optionSignature = radios.map((radio) => radio.value).join('|');
    if (select.dataset.egCartUxOptions !== optionSignature) {
      select.textContent = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = uxConfig.selectPlaceholder || 'Selecciona un canal';
      placeholder.disabled = true;
      select.appendChild(placeholder);
      radios.forEach((radio) => {
        const option = document.createElement('option');
        option.value = radio.value;
        option.textContent = radio.value;
        select.appendChild(option);
      });
      select.dataset.egCartUxOptions = optionSignature;
    }
    if (select.value !== current) select.value = current || '';

    const contact = preference.querySelector('.eg-digital-cart__contact');
    const status = preference.querySelector('[data-eg-digital-preference-status]');
    if (contact) {
      contact.classList.add('eg-cart-ux__contact');
      setNodeText(contact.querySelector('span'), uxConfig.digitalContactLabel || 'Contacto');
    }

    let contactRow = preference.querySelector('[data-eg-cart-ux-contact-row]');
    if (!contactRow && contact) {
      contactRow = document.createElement('div');
      contactRow.className = 'eg-cart-ux__contact-row';
      contactRow.dataset.egCartUxContactRow = '';
      preference.insertBefore(contactRow, status || null);
      contactRow.appendChild(contact);
      if (status) contactRow.appendChild(status);
    }

    if (status?.dataset.state === 'saved') setNodeText(status, uxConfig.savedText || 'Guardado');
  };

  const makePanelTitle = (title, symbol, type) => {
    const heading = document.createElement('div');
    heading.className = `eg-cart-ux__panel-title eg-cart-ux__panel-title--${type}`;
    heading.appendChild(makeIcon(symbol));
    const strong = document.createElement('strong');
    strong.textContent = title;
    heading.appendChild(strong);
    return heading;
  };

  const buildDigitalPanel = (digitalItems, metaMap, preference, uxConfig) => {
    const panel = document.createElement('section');
    panel.className = 'eg-cart-ux__panel eg-cart-ux__panel--digital';
    panel.appendChild(makePanelTitle(uxConfig.digitalBlockTitle || 'Producto digital', '↓', 'digital'));

    const meta = summarizeMeta(digitalItems, metaMap);
    const facts = document.createElement('div');
    facts.className = 'eg-cart-ux__facts';
    [
      makeFact(uxConfig.digitalPaymentLabel || 'Pago para el código digital', uxConfig.digitalPaymentText || 'Depósito o transferencia bancaria', '▣', 'payment'),
      makeFact(uxConfig.digitalDeliveryLabel || 'Entrega', uxConfig.digitalDeliveryText || '30 min–1 h después de confirmar el pago', '◷'),
      meta.region ? makeFact(uxConfig.digitalRegionLabel || 'Región', meta.region, '◎') : null,
      uxConfig.showRedeem !== false && meta.redeem ? makeFact(uxConfig.digitalRedeemLabel || 'Canje', meta.redeem, '◇') : null
    ].filter(Boolean).forEach((node) => facts.appendChild(node));
    panel.appendChild(facts);

    if (preference) {
      syncCompactPreference(preference, uxConfig);
      panel.appendChild(preference);
    }

    if (uxConfig.showReturns !== false && uxConfig.digitalReturnsText) {
      const warning = document.createElement('p');
      warning.className = 'eg-cart-ux__warning';
      warning.appendChild(makeIcon('!'));
      const span = document.createElement('span');
      span.textContent = uxConfig.digitalReturnsText;
      warning.appendChild(span);
      panel.appendChild(warning);
    }

    if (uxConfig.showConditionNote !== false && uxConfig.digitalConditionNote) {
      const note = document.createElement('p');
      note.className = 'eg-cart-ux__note';
      note.appendChild(makeIcon('i'));
      const span = document.createElement('span');
      span.textContent = uxConfig.digitalConditionNote;
      note.appendChild(span);
      panel.appendChild(note);
    }
    return panel;
  };

  const buildPhysicalPanel = (uxConfig) => {
    const panel = document.createElement('section');
    panel.className = 'eg-cart-ux__panel eg-cart-ux__panel--physical';
    panel.appendChild(makePanelTitle(uxConfig.physicalBlockTitle || 'Producto físico', '▰', 'physical'));
    const facts = document.createElement('div');
    facts.className = 'eg-cart-ux__facts';
    [
      makeFact(uxConfig.physicalPaymentLabel || 'Métodos de pago disponibles', uxConfig.physicalPaymentText || 'Depósito, transferencia, tarjeta, efectivo y pago contra entrega', '▣', 'payment'),
      makeFact(uxConfig.physicalDeliveryLabel || 'Entrega física', uxConfig.physicalDeliveryText || 'Continúa con el proceso normal de envío', '▰')
    ].filter(Boolean).forEach((node) => facts.appendChild(node));
    panel.appendChild(facts);

    if (uxConfig.showPhysicalPaymentNote !== false && uxConfig.physicalPaymentNote) {
      const note = document.createElement('p');
      note.className = 'eg-cart-ux__note';
      note.appendChild(makeIcon('✓'));
      const span = document.createElement('span');
      span.textContent = uxConfig.physicalPaymentNote;
      note.appendChild(span);
      panel.appendChild(note);
    }
    return panel;
  };

  const rebuildModule = (module, cart, uxConfig, metaMap) => {
    protectModule(module);
    const content = module.querySelector('.eg-digital-cart__content');
    if (!content) return;

    const digitalItems = (Array.isArray(cart?.items) ? cart.items : []).filter((item) => item.requires_shipping === false);
    const physicalItems = (Array.isArray(cart?.items) ? cart.items : []).filter((item) => item.requires_shipping !== false);
    if (!digitalItems.length) return;
    const mode = physicalItems.length ? 'mixed' : 'digital';

    const attributes = cart?.attributes || {};
    const signature = [
      mode,
      digitalItems.map((item) => `${item.key}:${item.quantity}`).join('|'),
      physicalItems.map((item) => `${item.key}:${item.quantity}`).join('|'),
      attributes[ATTRIBUTE_CHANNEL] || '',
      attributes[ATTRIBUTE_CONTACT] || '',
      JSON.stringify(digitalItems.map((item) => metaMap?.[String(item.variant_id)] || null)),
      JSON.stringify(uxConfig)
    ].join('::');

    const existingPreference = content.querySelector('[data-eg-digital-preference]');
    if (module.dataset.egCartUxSignature === signature && module.classList.contains('eg-cart-ux')) {
      syncCompactPreference(existingPreference, uxConfig);
      return;
    }

    if (existingPreference) existingPreference.remove();
    module.classList.add('eg-cart-ux');
    module.classList.toggle('eg-cart-ux--mixed', mode === 'mixed');
    module.classList.toggle('eg-cart-ux--digital', mode === 'digital');
    module.dataset.egCartUxSignature = signature;

    const head = module.querySelector('.eg-digital-cart__head');
    if (head) {
      head.textContent = '';
      head.className = 'eg-cart-ux__header';
      const icon = document.createElement('span');
      icon.className = 'eg-cart-ux__header-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = mode === 'mixed' ? '🛒' : '⚡';
      const copy = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = mode === 'mixed' ? (uxConfig.mixedTitle || 'TU CARRITO TIENE PRODUCTOS FÍSICOS Y DIGITALES') : (uxConfig.digitalOnlyTitle || 'COMPRA DIGITAL');
      const subtitle = document.createElement('p');
      subtitle.textContent = mode === 'mixed' ? (uxConfig.mixedSubtitle || 'Te mostramos por separado cómo se paga y entrega cada tipo de producto.') : (uxConfig.digitalOnlySubtitle || 'Revisa los datos esenciales de tu código antes de proceder al pago.');
      copy.append(title, subtitle);
      head.append(icon, copy);
    }

    content.textContent = '';
    const grid = document.createElement('div');
    grid.className = 'eg-cart-ux__grid';
    grid.appendChild(buildDigitalPanel(digitalItems, metaMap, existingPreference, uxConfig));
    if (mode === 'mixed') grid.appendChild(buildPhysicalPanel(uxConfig));
    content.appendChild(grid);

    if (mode === 'mixed' && uxConfig.showReassurance !== false && uxConfig.reassuranceText) {
      const reassurance = document.createElement('div');
      reassurance.className = 'eg-cart-ux__reassurance';
      reassurance.appendChild(makeIcon('✓'));
      const span = document.createElement('span');
      span.textContent = uxConfig.reassuranceText;
      reassurance.appendChild(span);
      content.appendChild(reassurance);
    }
  };

  const enhance = () => {
    enhanceTimer = null;
    const uxConfig = readJson(UX_CONFIG_SELECTOR);
    if (!uxConfig || uxConfig.enabled === false) return;
    syncDigitalPaymentPolicy(uxConfig);

    const modules = [...document.querySelectorAll(MODULE_SELECTOR)];
    if (!modules.length) return;
    modules.forEach(protectModule);

    const baseConfig = readJson(BASE_CONFIG_SELECTOR);
    if (!baseConfig || baseConfig.enabled === false || baseConfig.showCartSummary === false) return;
    const metaMap = readJson(META_SELECTOR) || {};

    fetchCart()
      .then((cart) => modules.forEach((module) => rebuildModule(module, cart, uxConfig, metaMap)))
      .catch(() => {});
  };

  const scheduleEnhance = () => {
    if (enhanceTimer) window.clearTimeout(enhanceTimer);
    enhanceTimer = window.setTimeout(enhance, 40);
  };

  const mutationTouchesDigitalCart = (mutation) => {
    const target = mutation.target instanceof Element ? mutation.target : mutation.target?.parentElement;
    if (target?.closest?.(MODULE_SELECTOR)) return true;
    return [...mutation.addedNodes].some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches(MODULE_SELECTOR) || Boolean(node.querySelector(MODULE_SELECTOR));
    });
  };

  const observer = new MutationObserver((mutations) => {
    if (!mutations.some(mutationTouchesDigitalCart)) return;
    scheduleEnhance();
  });

  const init = () => {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    scheduleEnhance();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', scheduleEnhance);
})();
